import { Box } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";

import CustomModal from "./components/CustomModal/CustomModal";
import { useGetQueryString } from "./hooks/useGetQueryString";
import useScreen from "./hooks/useScreen";
import { Channel } from "./interfaces/tracking";
import { TakePhotoPage } from "./pages/TakePhoto/TakePhoto";
import { VtoColor } from "./pages/vto/color/VtoColor";
import type { AppDispatch } from "./reducers/configureStore";
import { deleteSelfie } from "./reducers/selfie/selfieSlice";
import { setAceptTerms } from "./reducers/terms/termsSlide";
import { Analytics, EventNames } from "./utils/tracking";

export const Router = (props: any) => {
  const [isSessionExpiredOpen, setIsSessionExpiredOpen] = useState(false);

  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  let interval: any = undefined;
  const { isMobile } = useScreen();

  useEffect(() => {
    interval = setInterval(() => {
      const createPhoto = sessionStorage.getItem("takePhotoAt");
      if (createPhoto) {
        const TWENTYHOUR = 1000 * 60 * 60 * 20;
        const now = Date.now() - TWENTYHOUR;
        const createTime = new Date(createPhoto).getTime();
        if (now > createTime) {
          const page = new URLSearchParams(location.search).get("page");
          if (page && page !== "take-photo") {
            setIsSessionExpiredOpen(true);
            Analytics.event(Channel.GA, EventNames.SESSION_EXPIRED_LOADED, {
              device: isMobile ? "mobile" : "desktop",
            });
          }
        }
      }
    }, 1000 * 60 * 60 * 1);
    useGetQueryString();
    return () => clearInterval(interval);
  }, []);

  const gotItSessionExpired = () => {
    navigate({ search: "page=take-photo&try-on=color" });
    dispatch(deleteSelfie());
    dispatch(setAceptTerms(false));
    setIsSessionExpiredOpen(false);
  };

  return (
    <Routes>
      <Route
        path="*"
        element={
          <Box>
            <ParamsRouter {...props} />
            <CustomModal
              isOpen={isSessionExpiredOpen}
              showIcon={true}
              titleBtnConfirm="Got it!"
              onConfirm={gotItSessionExpired}
              title="Your session has expired."
              body="Your session ended, please take a photo again to continue the experience. "
            />
          </Box>
        }
      />
    </Routes>
  );
};

const ParamsRouter = (props: any) => {
  const location = useLocation();
  const page = new URLSearchParams(location.search).get("page");

  switch (page) {
    case "take-photo":
      return <TakePhotoPage from="Color Try-On" {...props} />;

    case "vto-color":
      return <VtoColor from="Color Try-On" {...props} />;

    default:
      return <Navigate to="?page=take-photo&try-on=color" replace />;
  }
};
